import "src/decidim/decidim_awesome/awesome_application.js"

// Images
require.context("../images", true)

// CSS
import "entrypoints/decidim_decidim_awesome.scss";


